export const ms = {
    global: {
        next: "Next",
        name: "Name",
        email: "Email",
        emailEtc: "name@example.com"
    },
    setupWizard: {
        stepOne: {
            title: "Welcome",
            hi: "Hi",
            header: "Welcome to Happily!",
            contentOne: "You’re awesome for initiating positive experiences in your workplace. With Happily, you’re enabling better feedback, recognition, learning, community and so much more!",
            contentTwo: "To get started, we need to get your team set up, select rewards, and send out invites. Let’s begin!",
            primaryLocation: "Primary Location",
        },
        stepTwo: {
            title: "Create Team",
            header: "Create Your Team",
            contentOne: "Happily works in teams and managers are at the center. Feedback, Insights, and Reports are sent to team managers on each workday to help them better understand their team in real-time. Help us set up your team.",
            teamName: "Team Name",
            teamNameEtc: "ACME Inc",
            managersNameEt: "Manager’s Name",
            email: "Email",
            memberName: "Member Name",
        },
        stepThree: {
            title: "Select Rewards",
            contentOne: "Your team can use coins and gems collected from answering daily questions (and other interactions) to redeem rewards! Select your rewards below. You can add custom rewards later on as well.",
            SelectOneTitle: "Company Perks",
            SelectOneContentOne: "Let your team redeem Early Release (leaving work early), Half-day Fridays, and Days Off and more!",
            SelectTwoTitle: "Gift Cards",
            SelectTwoContentOne: "Let your team redeem Gift Cards from local vendors and online stores.",
            SelectTwoContentTwo: "Buy credits to enable gift cards, no extra charges applied.",
        },
        stepFour: {
            title: "Confirm & Invite",
            contentOne: "We’re almost done! Set a time you’d like your teams to receive their daily pulse questions. We recommend selecting the time when your team is commuting to work.",
            quickSettings: "QUICK SETTINGS",
            dailyPulse: "Daily Pulse",
            whatHappensNext: "WHAT HAPPENS NEXT",
            contentOneWhatHappensNext: "Invitations will be sent out to your team and everyone will receive their first set of daily pulse questions on the next workday.",
            contentTwoWhatHappensNext: "Explore your admin console to add members, view insights, create custom questions & rewards, or edit your account settings.",
        },
    },
    weMonthlyInsights: {
        yourMonthlyInsights: "Your Monthly Insights",
        howTOUse: "CARA MENGGUNAKAN LAPORAN INI",
        thisReportIs: "Laporan ini dijana berdasarkan interaksi yang kami fasilitasi dalam aplikasi Happily. Tujuan maklumat ini adalah untuk membantu anda memahami diri sendiri dan pasukan anda dengan lebih baik. Hasil terbaik adalah perbualan yang membina kepercayaan, mengukuhkan kekuatan, dan membantu mengatasi cabaran.",
        monthly: {
            yourMonthlyInsights: "Pandangan Bulanan Anda untuk",
            createdfor: "Disediakan untuk",
            hereIsYour: "Ini adalah laporan penglibatan anda untuk",
            weRecommendThatboss: " Kami mencadangkan anda berkongsi pandangan dengan pasukan anda untuk memulakan perbualan yang produktif dan penambahbaikan berterusan. Semoga berjaya!",
            weRecommendThat: " Kami mencadangkan anda menggunakan ini sebagai panduan untuk memulakan perbualan yang produktif dengan pengurus anda ke arah penambahbaikan berterusan. Semoga berjaya!",
            yourContributions: "Sumbangan anda",
            dailyAttendance: "Kehadiran Harian",
            feedbackShared: "Maklum Balas Dikongsi",
            recognitionGiven: "Pengiktirafan Diberikan",
            peerFeedback: "Maklum Balas Raka",
            managerReplyRate: "Kadar Balasan Pengurus",
            insightsOpened: "Pandangan Dibuka",
            y_you: "ANDA",
            y_youTeam: "PASUKAN ANDA",
            howHaveWe: "Bagaimana perasaan kita sepanjang bulan lepas?",
            m_day: "M",
            t_day: "T",
            w_day: "W",
            th_day: "Th",
            f_day: "F",
            s_day: "S",
            su_day: "Su",
            yourTeam: "PASUKAN ANDA",
            overallYourTeam: "Secara keseluruhan, pasukan anda mempunyai",
            overallYourHad: "Secara keseluruhan, anda mempunyai",
            good: "good,",
            justOkay: "just okay,",
            and: "and",
            criticalDays: "critical days.",
            remidner: "REMINDER",
            yourPrimaryRole: "Peranan utama anda sebagai pengurus bukanlah untuk memastikan semua orang gembira setiap hari. Ia adalah untuk memastikan pasukan anda dapat bangkit semula dengan cepat daripada kemunduran dan untuk memahami & mengembangkan bakat anda serta membantu menyelesaikan cabaran pasukan.",
            howAreWe: "Bagaimana prestasi kita dalam dimensi yang berbeza?",
            keyAreasOf: "Bidang utama kekuatan dan cabaran untuk anda renungkan bersama pengurus anda",
            keyAreasOfฺBoss: "Bidang utama kekuatan dan cabaran untuk diberi tumpuan bersama laporan langsung anda",
            focusOnGetting: "Fokus untuk mengenali diri anda dengan lebih baik. Sentiasa ada pasang surut. Jangan segan untuk mendapatkan bantuan apabila diperlukan.",
            andYouHave: "Dan anda mempunyai kuasa untuk menjadikan hari seseorang lebih baik. ",
            howconsist: "Seberapa konsisten anda selama ini?",
            consistencycontributions: "Anda telah menyumbang pada tahap ",
            consistency: "consistency.",
            month_1: "Jan",
            month_2: "Feb",
            month_3: "Mar",
            month_4: "Apr",
            month_5: "May",
            month_6: "Jun",
            month_7: "Jul",
            month_8: "Aug",
            month_9: "Sep",
            month_10: "Oct",
            month_11: "Nov",
            month_12: "Dec",
        },
        strengths: {
            whatAreOur: "Apakah kekuatan kita sebagai pasukan dan syarikat?",
            keyAreasOf: "Bidang utama kekuatan 💪 dan cabaran ⚠️ untuk diberi tumpuan bersama pasukan anda",
        },
        engaged: {
            howEngagedAre: "Sejauh mana penglibatan kita pada masa ini?",
            progressBasedOn: "Berdasarkan tingkah laku berkaitan maklum balas, pengiktirafan, dan penambahbaikan diri",
            previousMonth: "Bulan sebelumnya",
            _engaged: "Engaged",
            _super: "Super",
            _highly: "Highly",
            _moderately: "Engaged",
            _somewhat: "Somewhat",
            _not: "Under",
            inActive: "Tidak Aktif",
            youHave: "Anda mempunyai",
            superEngaged: "Super Engaged",
            highlyEngaged: "Highly Engaged",
            moderatelyEngaged: "Engaged",
            somewhatEngaged: "Somewhat Engaged",
            notEngaged: "Not Engaged",
            underEngaged: "Under Engaged",
            youAre: "Anda",
            hereIsAn: " Berikut adalah gambaran keseluruhan bidang penglibatan & cabaran utama anda:",
            membersOnYour: "ahli dalam pasukan anda. Buka bidang penting untuk meningkatkan penglibatan.",
            dailyCheckIns: "Daily Check-ins",
            peerFeedback: "Peer Feedback",
            _feedback: "Feedback",
            happilyVillage: "Happily Village",
            superFeedback: "Super Feedback",
            rewards: "Rewards",
            recognition: "Recognition",
            favoritedSparks: "Favorited Sparks",
            superRecognition: "Super Recognition",
            networkBuilding: "Network Building",
            youIndicatedThat: "You indicated that",
            isNoLonger: "is no longer on the team. How can we help?",
            cancel: "Cancel",
            notifyAdmins: "Notify Admins",
        },
        connections: {
            howAreWe: "Bagaimana kita membina hubungan?",
            basedOnRecognition: "Berdasarkan pengiktirafan, maklum balas rakan sekerja, dan interaksi hadiah",
            youHaveA: "Anda mempunyai sejumlah",
            connections: "connections",
            innerNetwork: "Inner network",
            newConnectionsThis: "hubungan baharu bulan ini",
            outerNetwork: "Outer network",
            buildingRelationshipsIs: "Membina hubungan adalah bahagian penting dalam tempat kerja kita. Rangkaian dalaman yang kukuh menggalakkan kerjasama. Rangkaian luaran yang kukuh membantu kita mengumpul maklumat baharu, idea, dan menyelesaikan masalah.",
        },
        growing: {
            howAreWe: "Bagaimana kita berkembang dan membangun?",
            progressBasedOn: "Kemajuan anda berdasarkan pengiktirafan pengurus & rakan sekerja dan maklum balas rakan sekerja",
            youAreHere: "Anda di sini",
            youWereHere: "Anda berada di sini",
            progressBasedOnBoss: "Kemajuan anda dan pasukan berdasarkan pengiktirafan pengurus & rakan sekerja dan maklum balas rakan sekerja",
            individualPerformance: "Individual Performance (Pengurus)",
            networkEffectiveness: "Network Effectiveness (Rakan Sekerja)",
            s_starPerformer: "STAR PERFORMER",
            trulyOutstanding: "Truly Outstanding",
            yourDirectReports: "Laporan Langsung Anda",
            showMore: "Muat lebih banyak ",
            didNotParticipate: "Tidak mengambil bahagian atau menerima Maklum Balas Rakan Sekerja bulan ini",            
            Impact_Rating: "Impact Rating",
            Network_Type: "Network Type",
            Achievements: "Achievements",
            POOR: "LEMAH",
            LOW:"RENDAH",
            OKAY: "SEDERHANA",
            GREAT: "BAGUS",
            EXCELLENT: "CEMERLANG",
            A_score_that_represents: "Skor yang menunjukkan impak seseorang terhadap organisasi dan orang di sekeliling mereka ditentukan oleh:",
            Based_on_manager_and: "Berdasarkan pengiktirafan pengurus dan rakan sekerja dalam tempoh 6 bulan yang lalu.",
            Truly_Outstanding_ratings_from: "Penarafan Sangat Cemerlang daripada Maklum Balas Rakan Sekerja yang diterima dalam tempoh 6 bulan yang lalu.",
            Number_of_weeks_qualified: "Bilangan minggu yang layak sebagai Pekerja Cemerlang dalam tempoh 6 bulan yang lalu.",
            Medals_received_in_the: "Pingat yang diterima dalam tempoh 6 bulan yang lalu.",
            Based_on_connections_created: "Berdasarkan hubungan yang dibina melalui maklum balas rakan sekerja, pengiktirafan, dan interaksi pemberian hadiah dalam tempoh 6 bulan yang lalu.",
            Based_on_the_quality_and: "Berdasarkan kualiti dan usaha tingkah laku penglibatan utama bulan lepas",
        }
    },
    weQuarterlyInsights: {
        yourQuarterlyInsights: "Wawasan Suku Tahunan Anda",
        howTOUse: "CARA MENGGUNAKAN LAPORAN INI",
        thisReportIs: "Laporan ini dijana berdasarkan interaksi yang kami fasilitasi dalam aplikasi Happily. Tujuan maklumat ini adalah untuk membantu anda membangunkan pemahaman yang lebih baik tentang diri sendiri dan pasukan anda. Hasil terbaik adalah perbualan yang membina kepercayaan, mengukuhkan kekuatan, dan membantu mengatasi cabaran.",
        quarterly: {
            yourQuarterlyInsights: "Wawasan Suku Tahunan Anda untuk",
            createdfor: "Dicipta untuk",
            hereIsYour: "Berikut adalah laporan penglibatan anda untuk",
            weRecommendThatboss: " Kami mengesyorkan anda berkongsi pandangan dengan pasukan anda yang akan memulakan perbualan yang produktif dan penambahbaikan berterusan. Semoga berjaya!",
            weRecommendThat: " Kami mengesyorkan anda menggunakan ini sebagai panduan untuk memulakan perbualan yang produktif dengan pengurus anda ke arah penambahbaikan berterusan. Semoga berjaya!",
            yourContributions: "Sumbangan anda",
            dailyAttendance: "Kehadiran Harian",
            feedbackShared: "Maklum Balas Dikongsi",
            recognitionGiven: "Pengiktirafan Diberikan",
            peerFeedback: "Maklum Balas Rakan Sebaya",
            managerReplyRate: "Kadar Balasan Pengurus",
            insightsOpened: "Wawasan Dibuka",
            y_you: "ANDA",
            y_youTeam: "PASUKAN ANDA",
            howHaveWe: "Bagaimana perasaan kita sepanjang suku tahun yang lalu?",
            m_day: "I",
            t_day: "S",
            w_day: "R",
            th_day: "K",
            f_day: "J",
            s_day: "S",
            su_day: "A",
            yourTeam: "PASUKAN ANDA",
            overallYourTeam: "Secara keseluruhan, pasukan anda mempunyai",
            overallYourHad: "Secara keseluruhan, anda mempunyai",
            good: "baik,",
            justOkay: "sederhana,",
            and: "dan",
            criticalDays: "hari kritikal.",
            remidner: "PERINGATAN",
            yourPrimaryRole: "Peranan utama anda sebagai pengurus tidak membuat semua orang gembira setiap hari. Ia adalah untuk memastikan pasukan anda pulih dengan cepat daripada kemunduran dan memahami & membangunkan bakat anda dan membantu menyelesaikan cabaran pasukan.",
            howAreWe: "Bagaimana prestasi kita dalam dimensi yang berbeza?",
            keyAreasOf: "Bidang utama kekuatan dan cabaran untuk anda fikirkan dengan pengurus anda",
            keyAreasOfฺBoss: "Bidang utama kekuatan dan cabaran untuk difokuskan dengan laporan langsung anda",
            focusOnGetting: "Fokus untuk mengenali diri sendiri dengan lebih baik. Sentiasa akan ada pasang surut. Jangan malu untuk meminta bantuan apabila diperlukan.",
            andYouHave: "Dan anda mempunyai kuasa untuk menjadikan hari seseorang lebih baik. ",
            howconsist: "Sejauh mana konsistensi anda?",
            consistencycontributions: "Anda telah menyumbang pada ",
            consistency: "konsistensi.",
            month_1: "Jan",
            month_2: "Feb",
            month_3: "Mac",
            month_4: "Apr",
            month_5: "Mei",
            month_6: "Jun",
            month_7: "Jul",
            month_8: "Ogos",
            month_9: "Sep",
            month_10: "Okt",
            month_11: "Nov",
            month_12: "Dis",
        },
        strengths: {
            whatAreOur: "Kekuatan Utama & Bidang Fokus Suku Tahun Ini",
            keyAreasOf: "Bidang yang menunjukkan kekuatan konsisten dan yang memerlukan perhatian sepanjang suku tahun",
        },
        engaged: {
            howEngagedAre: "Sejauh mana penglibatan kita pada masa ini?",
            progressBasedOn: "Berdasarkan tingkah laku berkaitan maklum balas, pengiktirafan, dan penambahbaikan diri",
            previousMonth: "Suku tahun sebelumnya",
            _engaged: "Terlibat",
            _super: "Super",
            _highly: "Tinggi",
            _moderately: "Terlibat",
            _somewhat: "Agak",
            _not: "Bawah",
            inActive: "Tidak Aktif",
            youHave: "Anda mempunyai",
            superEngaged: "Super Terlibat",
            highlyEngaged: "Sangat Terlibat",
            moderatelyEngaged: "Terlibat",
            somewhatEngaged: "Agak Terlibat",
            notEngaged: "Tidak Terlibat",
            underEngaged: "Kurang Terlibat",
            youAre: "Anda adalah",
            hereIsAn: " Berikut adalah gambaran keseluruhan bidang penglibatan & cabaran utama anda:",
            membersOnYour: "ahli dalam pasukan anda. Buka kunci bidang kritikal untuk meningkatkan penglibatan.",
            dailyCheckIns: "Daftar Masuk Harian",
            peerFeedback: "Maklum Balas Rakan Sebaya",
            _feedback: "Maklum Balas",
            happilyVillage: "Kampung Happily",
            superFeedback: "Maklum Balas Super",
            rewards: "Ganjaran",
            recognition: "Pengiktirafan",
            favoritedSparks: "Sparks Kegemaran",
            superRecognition: "Pengiktirafan Super",
            networkBuilding: "Pembinaan Rangkaian",
            youIndicatedThat: "Anda menunjukkan bahawa",
            isNoLonger: "tidak lagi dalam pasukan. Bagaimana kami boleh membantu?",
            cancel: "Batal",
            notifyAdmins: "Maklumkan Pentadbir",
        },
        connections: {
            howAreWe: "Bagaimana kita membina sambungan kita?",
            basedOnRecognition: "Berdasarkan pengiktirafan, maklum balas rakan sebaya, dan interaksi hadiah",
            youHaveA: "Anda mempunyai sejumlah",
            connections: "sambungan",
            innerNetwork: "Rangkaian dalaman",
            newConnectionsThis: "sambungan baharu suku tahun ini",
            outerNetwork: "Rangkaian luar",
            buildingRelationshipsIs: "Membina hubungan adalah bahagian penting dalam tempat kerja kita. Rangkaian dalaman yang kuat memupuk kerjasama. Rangkaian luar yang kuat membantu kita mengumpul maklumat, idea baharu, dan menyelesaikan masalah.",
        },
        growing: {
            howAreWe: "Bagaimana kita berkembang dan membangun?",
            progressBasedOn: "Kemajuan anda berdasarkan pengiktirafan pengurus & rakan sebaya dan maklum balas rakan sebaya",
            youAreHere: "Anda berada di sini",
            youWereHere: "Anda pernah berada di sini",
            progressBasedOnBoss: "Kemajuan anda dan pasukan anda berdasarkan pengiktirafan pengurus & rakan sebaya dan maklum balas rakan sebaya",
            individualPerformance: "Prestasi Individu (Pengurus)",
            networkEffectiveness: "Keberkesanan Rangkaian (Rakan Sebaya)",
            s_starPerformer: "PRESTASI BINTANG",
            trulyOutstanding: "Benar-benar Cemerlang",
            yourDirectReports: "Laporan Langsung Anda",
            showMore: "Muatkan lebih banyak ",
            didNotParticipate: "Tidak mengambil bahagian atau menerima Maklum Balas Rakan Sebaya suku tahun ini",
            Impact_Rating: "Penarafan Impak",
            Network_Type: "Jenis Rangkaian",
            Achievements: "Pencapaian",
            POOR: "LEMAH",
            LOW:"RENDAH",
            OKAY: "OKAY",
            GREAT: "HEBAT",
            EXCELLENT: "CEMERLANG",
            A_score_that_represents: "Skor yang mewakili impak individu terhadap organisasi dan orang di sekeliling mereka, ditentukan oleh:",
            Based_on_manager_and: "Berdasarkan pengiktirafan pengurus dan rakan sebaya dalam 6 bulan yang lalu.",
            Truly_Outstanding_ratings_from: "Penilaian Benar-benar Cemerlang daripada Maklum Balas Rakan Sebaya yang diterima dalam 6 bulan yang lalu.",
            Number_of_weeks_qualified: "Bilangan minggu layak sebagai Prestasi Bintang dalam 6 bulan yang lalu.",
            Medals_received_in_the: "Pingat yang diterima dalam 6 bulan yang lalu.",
            Based_on_connections_created: "Berdasarkan sambungan yang dibuat melalui maklum balas rakan sebaya, pengiktirafan, dan interaksi pemberian hadiah dalam 6 bulan yang lalu.",
            Based_on_the_quality_and: "Berdasarkan kualiti dan usaha tingkah laku penglibatan utama suku tahun lepas.",
        }
    },
    questionDetail: {
        QUESTION_DETAILS: "QUESTION DETAILS",
        Scale: "Scale",
        Multiple_Choice: "Multiple Choice",
        Yes_No: "Yes/No",
        average: "purata",
        out_of_10: "daripada 10",
        responses: "maklum balas",
        response: "maklum balas",
        score: "skor",
    },
};